import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pharma-hub-85/artifacts/uc3c8jaq_43afdbdc-0274-4dad-a371-a86aa1080642_removalai_preview.png";

const Footer = () => {
  return (
    <footer className="bg-[#1e3a5f] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src={LOGO_URL} 
                alt="PolyMax Medicine" 
                className="h-14 w-auto object-contain bg-white rounded-lg p-1"
              />
              <span className="font-bold text-xl">PolyMax Medicine</span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Azərbaycanda əczaçılıq sahəsində lider şirkət. Keyfiyyətli dərmanlar, sağlam həyat.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Sürətli Keçidlər</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-slate-300 hover:text-white transition-colors text-sm">Ana Səhifə</Link></li>
              <li><Link to="/products" className="text-slate-300 hover:text-white transition-colors text-sm">Məhsullar</Link></li>
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors text-sm">Haqqımızda</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors text-sm">Əlaqə</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Əlaqə</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-sm text-slate-300">
                <Phone className="h-4 w-4 text-[#25d366]" />
                <span>+994 50 655 55 01</span>
              </li>

              <li className="flex items-center space-x-3 text-sm text-slate-300">
                <Mail className="h-4 w-4 text-[#3b82f6]" />
                <span>Medicinepolymax@gmail.com</span>
              </li>

              <li className="flex items-center space-x-3 text-sm text-slate-300">
                <Instagram className="h-4 w-4 text-[#E1306C]" />
                <a 
                  href="https://www.instagram.com/polymax.az/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  @polymax.az
                </a>
              </li>

              <li className="flex items-start space-x-3 text-sm text-slate-300">
                <MapPin className="h-4 w-4 mt-0.5" />
                <span>Bakı şəhəri, Azərbaycan</span>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div>
            <h3 className="font-semibold text-lg mb-4">İş Saatları</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-sm text-slate-300">
                <Clock className="h-4 w-4" />
                <span>7/24</span>
              </li>
              
         
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-600 mt-12 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} PolyMax Medicine. Bütün hüquqlar qorunur.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;